import { useState } from "react";
import { useBuyerRelationshipCreate } from "./api/v2/buyerRelationship/useBuyerRelationshipCreate";
import { useBuyerRelationshipList } from "./api/v2/buyerRelationship/useBuyerRelationshipList";

export const useSupplierAddToList = ({
  supplierId,
}: {
  supplierId: number;
}) => {
  const [isAdded, setIsAdded] = useState<boolean>(false);
  const buyerRelationshipListQuery = useBuyerRelationshipList(
    {
      query: [
        {
          type: "supplierId",
          modifier: "EQUALS",
          value: supplierId,
        },
      ],
      limit: 1,
    },

    {
      enabled: !!supplierId,
    },
  );
  const addToListMutation = useBuyerRelationshipCreate();

  const handleAddToList = () => {
    addToListMutation.mutate(
      {
        SupplierId: supplierId,
      },
      {
        onSuccess: () => setIsAdded(true),
        onError: () => setIsAdded(false),
      },
    );
  };

  const buyerRelationship = buyerRelationshipListQuery.data?.pages[0]?.[0];

  return {
    isAdded: !!buyerRelationship || isAdded,
    handleAddToList,
  };
};
